<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="ri-money-rupee-circle-line me-1 text-primary"></i>Salaries
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Filter by Salary Date" placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" id="search"
                                        placeholder="Salary date..." autocomplete="off" [(ngModel)]="salaryDate">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        class=" btn btn-secondary btn-sm "  (click)="onSalaryChange()" >
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto ms-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertSalary()"
                                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): payroll.salary.edit' : ''">
                                    <i class="bx bx-plus"></i> Add Salary
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="300">Frequency</th>
                                    <th scope="col" width="300">From Date</th>
                                    <th scope="col" width="300">To Date</th>
                                    <th scope="col" width="300" class="text-center">Provident Fund</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let salary of salaries | search : 'name' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{salary.frequency}}</td>
                                    <td>{{salary.fromDate  | date:'MMM dd, yyyy'}}</td>
                                    <td>{{salary.toDate  | date:'MMM dd, yyyy'}}</td>
                                    <td class="text-center">{{ salary.providentFundName || '-' }}</td>
                                    <!-- <td class="p-0 text-center">
                                        <button data-bs-toggle="modal" class="btn btn-secondary btn-sm" 
                                                *ngIf="salary?.active && salary?.status !== 'DONE' && (salary?.status === 'NIL' || salary?.status === 'DUE')"
                                                data-bs-target="#salaryModal" (click)="upsertPayment(salary)">
                                            <i class='bx bx-credit-card size'></i> 
                                            {{ salary?.status === 'NIL' ? 'Due' : 'Pay' }}
                                        </button>  
                                    </td> -->
                                    <td class="actions">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" [id]="i"
                                                [checked]="salary.active" [ngClass]="{
                                                    'no-event': salary?.isDeleteInProgress,
                                                    'not-allowed': !privilege.canEdit
                                                }"
                                                 [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): payroll.salary.edit' :salary.active ? 'Mark '  + ' as active.' : 'Mark ' +  ' as inactive.'"
                                                placement="top" container="body" [(ngModel)]="salary.active"
                                                (change)="toggleSalaryStatus(salary)"><label class="form-check-label"
                                                [for]="i"></label>
                                        </div>
                                        <i class="bx bx-show alert-info"
                                            [ngClass]="{'no-event':salary?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit? 'You need permissions for this action. Required permission(s): payroll.salary.edit' : 'View Payments'"
                                            [routerLink]="['/payroll/payment-list']"
                                            [queryParams]="{salary: salary, sid: salary.id,fromDate: getFormattedDate(salary.fromDate),toDate: getFormattedDate(salary.toDate)}">
                                        </i>
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event':salary?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): payroll.salary.edit' : 'Update Salary'"
                                            (click)="upsertSalary(salary)"></i>
                                        <!-- <i *ngIf="!salary?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed':!privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): payroll.salary.delete' : 'Delete Salary'"
                                            (click)="deleteSalary(salary,i)"></i> -->
                                        <div *ngIf="salary?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="7">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container *ngIf="salaries && salaries.length < 1; else noSearchResults">
                                            <td colspan="7">No salaries were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="7"
                                                *ngIf="searchKeyword && (salaries | search : 'name' : searchKeyword).length == 0">
                                                No salaries were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>